<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        The density of a piece of ebony wood is
        <stemble-latex content="$1.20\,\text{g/cm}^3.$" />
        What is the volume (in
        <stemble-latex content="$\text{cm}^3$)" />
        of a piece of this wood that has a mass of
        <number-value :value="mass" unit="\text{kg?}" />
      </p>
      <calculation-input
        v-model="inputs.input1"
        prepend-text="$\text{Volume}:$"
        append-text="$\text{cm}^3$"
        class="mb-4"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import NumberValue from '../NumberValue';

export default {
  name: 'Question189',
  components: {
    StembleLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    mass() {
      return this.taskState.getValueBySymbol('mass').content;
    },
  },
};
</script>
